// import React, { useState, useEffect } from 'react';
import Logo from '../../../../assets/images/neophyte_logo.png';
// import './video.css';
// const infer_localUrl = 'http://localhost:9990';

import { Button, CircularProgress } from '@mui/material';
import { Box } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const VideoComponent = () => {
  const [playing, setPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [streamUrl, setStreamUrl] = useState('');
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  const cameraData = useSelector((state) => state.cameraReducer.cameraData);
  const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);

  console.log('Current cameraData in VideoComponent:', cameraData);
  console.log('Current videoPlaying state:', videoPlaying);

  const formatVideoUrl = (url) => {
    if (!url) return '';

    if (url.includes('drive.google.com/file/d/')) {
      const fileIdMatch = url.match(/\/d\/([^/]+)/);
      if (fileIdMatch && fileIdMatch[1]) {
        const fileId = fileIdMatch[1];
        return `https://drive.google.com/file/d/${fileId}/preview`;
      }
    }

    return url;
  };

  useEffect(() => {
    if (cameraData && cameraData.videoUrl) {
      console.log('Processing camera data:', cameraData);

      setIsLoading(true);
      setError(null);

      try {
        const url = formatVideoUrl(cameraData.videoUrl);
        console.log('Setting stream URL:', url);
        setStreamUrl(url);
        setPlaying(videoPlaying);

        if (videoPlaying !== true) {
          dispatch({ type: 'VIDEO_PLAYING', videoPlaying: true });
        }
      } catch (err) {
        console.error('Error processing camera data:', err);
        setError('Failed to process video URL');
        setPlaying(false);
      } finally {
        setTimeout(() => setIsLoading(false), 500);
      }
    } else {
      console.log('No camera data or URL available');
      setPlaying(false);
      setStreamUrl('');
      dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
    }
  }, [cameraData, videoPlaying, dispatch]);

  // const playCamera = (camera) => {
  //   console.log('Direct play camera called with:', camera);
  //   if (camera && camera.videoUrl) {
  //     dispatch({
  //       type: 'SET_CAMERA',
  //       cameraData: camera
  //     });
  //     dispatch({
  //       type: 'VIDEO_PLAYING',
  //       videoPlaying: true
  //     });
  //   }
  // };

  const handleVideoError = (e) => {
    console.error('Error loading video stream:', e);
    setError(`Failed to load video from: ${streamUrl}`);
    setPlaying(false);
    dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false });
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const retryVideo = () => {
    if (cameraData && cameraData.videoUrl) {
      setIsLoading(true);
      setError(null);

      setTimeout(() => {
        const url = formatVideoUrl(cameraData.videoUrl);
        setStreamUrl(url);
        setPlaying(true);
        dispatch({ type: 'VIDEO_PLAYING', videoPlaying: true });
        setIsLoading(false);
      }, 1000);
    }
  };

  const videoHeight = isFullScreen ? '85vh' : '60vh';

  return (
    <div className="video-component">
      {isLoading ? (
        <div style={{ height: videoHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress />
          <p className="ml-2">Loading video stream...</p>
        </div>
      ) : error ? (
        <div style={{ height: videoHeight }} className="flex flex-col justify-center items-center">
          <div className="text-red-500 mb-4">{error}</div>
          <Button variant="contained" onClick={retryVideo}>
            Retry
          </Button>
        </div>
      ) : playing && streamUrl ? (
        <div className="video-container relative">
          <iframe
            className="border border-black"
            width={'100%'}
            height={'100%'}
            id="videoElement"
            src={streamUrl}
            style={{ height: videoHeight }}
            allow="autoplay"
            allowFullScreen
            onError={handleVideoError}
          />
          <button
            className="fullscreen-button"
            onClick={toggleFullScreen}
            style={{
              position: 'absolute',
              bottom: '10px',
              right: '10px',
              background: 'rgba(0,0,0,0.5)',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer'
            }}
          >
            {isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'}
          </button>
        </div>
      ) : (
        <div style={{ height: '65vh', width: '65vw' }} className="flex justify-center items-center">
          <img src={Logo} alt="Neophyte Logo" className="w-full h-full object-contain" />
        </div>
      )}

      <div className="controls">
        <Box sx={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'center' }}>
          <div className="bottom-controls">
            <input type="text" placeholder="Search" className="search-bar" />
          </div>
        </Box>
      </div>
    </div>
  );
};

export default VideoComponent;
